import { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import logo from "../img/Logo.png";
import "../i18n";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng) => {
    const currentPath = location.pathname;
    const pathParts = currentPath.split("/").filter(Boolean);

    let newPath = "/";
    if (lng !== "az") {
      newPath = `/${lng}`;
    }

    if (pathParts.length > 1) {
      newPath += "/" + pathParts.slice(1).join("/");
    }

    i18n.changeLanguage(lng);
    localStorage.setItem("lng", lng);
    navigate(newPath, { replace: true });
  };

  // useEffect(() => {
  //   changeLanguage(localStorage.getItem("lng") || "az");
  // }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY && window.scrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full bg-white/20 backdrop-blur-sm shadow-md z-50 transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="flex items-center justify-between px-4 py-4 mx-auto w-full max-w-screen-xl">
        <a href="/" className="flex items-center">
          <img className="w-32 h-auto" src={logo} alt="Logo" />
        </a>

        <div className="hidden md:flex items-center space-x-8">
          <ul className="flex space-x-6 text-gray-700 dark:text-gray-300">
            {[
              { label: t("nav_home"), to: "home" },
              { label: t("nav_about"), to: "about" },
              { label: t("nav_products"), to: "products" },
              { label: t("nav_contact"), to: "contact" },
            ].map((item, index) => (
              <li key={index}>
                <ScrollLink
                  to={item.to}
                  smooth={true}
                  duration={1500}
                  className="cursor-pointer hover:text-cyan-700 dark:hover:text-white transition"
                >
                  {item.label}
                </ScrollLink>
              </li>
            ))}
          </ul>
          <div className="flex items-center ">
            {["az", "en", "ru"].map((lang, index) => (
              <span key={lang} className="flex items-center space-x-1">
                {index > 0 && <span className="text-gray-500">|</span>}
                <button
                  onClick={() => changeLanguage(lang)}
                  className={`px-4 py-2 text-gray-700 rounded ${
                    i18n.language === lang ? "underline underline-offset-4" : ""
                  }`}
                >
                  {lang.toUpperCase()}
                </button>
              </span>
            ))}
          </div>
        </div>

        <button
          onClick={toggleMenu}
          className="inline-flex items-center md:hidden p-2 text-gray-500 hover:bg-gray-100"
        >
          <svg
            className="w-6 h-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>
      </div>

      <div
        className={`fixed top-0 left-0 w-full h-screen bg-gray-800 text-white flex flex-col items-center justify-center transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } md:hidden`}
      >
        <button
          onClick={toggleMenu}
          className="absolute top-5 right-5 text-white text-3xl"
        >
          ✕
        </button>
        <ul className="flex flex-col space-y-6 text-2xl">
          {[
            { label: t("nav_home"), to: "home" },
            { label: t("nav_about"), to: "about" },
            { label: t("nav_products"), to: "products" },
            { label: t("nav_contact"), to: "contact" },
          ].map((item, index) => (
            <li key={index}>
              <ScrollLink
                to={item.to}
                smooth={true}
                duration={500}
                onClick={toggleMenu}
                className="cursor-pointer hover:text-cyan-400 transition"
              >
                {item.label}
              </ScrollLink>
            </li>
          ))}
        </ul>
        <div className="absolute bottom-20 flex space-x-2 text-lg">
          {["az", "en", "ru"].map((lang, index) => (
            <span key={lang} className="flex items-center space-x-1">
              {index > 0 && <span className="text-gray-300">|</span>}
              <button
                onClick={() => {
                  changeLanguage(lang);
                  setIsOpen(false);
                }}
                className={`px-1 py-1 text-white rounded ${
                  i18n.language === lang ? "underline underline-offset-4" : ""
                }`}
              >
                {lang.toUpperCase()}
              </button>
            </span>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
